import { photoLayoutConfig } from '~/components/photoLayoutConfig';
import { PhotoLayout } from './PhotoLayout';

export function RearPhoto() {
  return <PhotoLayout {...photoLayoutConfig['rear']} />;
}
